import React, { FC } from 'react';
import { FormInput } from '../merchants/FormInput';
import { InputType } from '../form/form-input-constants';
import { ButtonComponent } from '../ButtonComponent';
import { useFormik } from 'formik';
import {
	ACCOUNT_FORM_FIELDS, ACCOUNT_FORM_FIELDS_NAMES,
	accountInitialValues,
	convertToAccountInitialValues,
	getAccountDetailsSchema, IAccountFieldTypes
} from '../../constants/accounts/account-form';
import { useTranslation } from 'react-i18next';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { IAccount } from '../../store/merchnts/merchant-interfaces';
import { setAccount } from '../../store/merchnts/actions/account';

interface Props {
	onSuccess: () => void;
	onError: () => void;
	account?: IAccount | null;
	setChosenAccount?: (value: IAccount | null) => void;
}

export const AddNewAccount: FC<Props> = (props) => {
	const { onSuccess, onError, account, setChosenAccount } = props;
	const { t } = useTranslation();
	const { merchantState, dispatch } = useMerchants();
	const { isAddNewAccountLoading } = merchantState;
	const formik = useFormik<IAccountFieldTypes>({
		initialValues: account
			? convertToAccountInitialValues(account)
			: accountInitialValues,
		validationSchema: getAccountDetailsSchema(t),
		onSubmit: () => setAccount(dispatch, formik, account, setChosenAccount, onSuccess, onError)
	});

	// const INPUTS = ACCOUNT_INPUTS({ t, account, emailAdditionalClasses });

	return (
		<form className="row px-6 w-100" onSubmit={formik.handleSubmit}>
			<FormInput
				formik={formik}
				key={ACCOUNT_FORM_FIELDS.ACCOUNT_NAME}
				fieldName={ACCOUNT_FORM_FIELDS.ACCOUNT_NAME}
				label={t(ACCOUNT_FORM_FIELDS_NAMES.ACCOUNT_NAME)}
				placeholder={`${t('NEW_APPLICATION.ENTER')} ${t(ACCOUNT_FORM_FIELDS_NAMES.ACCOUNT_NAME)}`}
				required
				inputType={InputType.Text}
				additionalClasses="col-sm-6 col-md-6"
			/>
			<div className="col-6 mt-7">
				<ButtonComponent
					additionalClass="d-block ms-auto w-85px btn-sm"
					buttonName={t('PARTNERS.SAVE_BTN_NAME')}
					loading={isAddNewAccountLoading}
					isDisabled={isAddNewAccountLoading}
					type="submit"
				/>
			</div>
		</form>
	);
};
